import React from 'react';
import PropTypes from 'prop-types';

function DividerDashSeparator({ color, width, height }) {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* eslint-disable-next-line max-len */}
      <path fill-rule="evenodd" clipRule="evenodd" d="M2.99999 1.99984H59C60.1046 1.99984 61 2.89568 61 3.99988C61 5.10455 60.1046 5.99991 59 5.99991H2.99999C1.8954 5.99991 0.999998 5.10455 0.999998 3.99988C0.999998 2.89568 1.8954 1.99984 2.99999 1.99984Z" fill={color} />
      {/* eslint-disable-next-line max-len */}
      <path fill-rule="evenodd" clipRule="evenodd" d="M68 1.99984H80C81.1045 1.99984 82 2.89568 82 3.99988C82 5.10455 81.1045 5.99991 80 5.99991H68C66.8954 5.99991 66 5.10455 66 3.99988C66 2.89568 66.8954 1.99984 68 1.99984Z" fill={color} />
      {/* eslint-disable-next-line max-len */}
      <path fill-rule="evenodd" clipRule="evenodd" d="M89 1.99984H91C92.1046 1.99984 93 2.89568 93 3.99988C93 5.10455 92.1046 5.99991 91 5.99991H89C87.8954 5.99991 86.9999 5.10455 86.9999 3.99988C86.9999 2.89568 87.8954 1.99984 89 1.99984Z" fill={color} />
    </svg>
  );
}

DividerDashSeparator.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

DividerDashSeparator.defaultProps = {
  color: '#232323',
  width: '94',
  height: '7',
};

export default React.memo(DividerDashSeparator);
